import { Operator } from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';

const BooleanType = ({fieldName, showLabel, selectedOperator}) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
      return (
        <EqualValue fieldName={fieldName} showLabel={showLabel} />
      );

    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS UNDEFINED*/}</>;

    default:
      return <></>;
  }

}

export default BooleanType;